import * as React from "react";
const SvgFiRrKiwiBird = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-kiwi-bird_svg__a)">
      <path
        fill="#062147"
        d="M18 4.5A1.5 1.5 0 1 1 15 4.499 1.5 1.5 0 0 1 18 4.5m5.937 11.965a.522.522 0 0 1-1.038.089c-.194-1.353-1.028-5.483-4.208-8.126a4.4 4.4 0 0 1-1.046.417c-.475.123-.645.682-.645 1.164v1.212c0 3.195-1.866 6.166-4.503 7.696l.495 3.959a1 1 0 0 1-.868 1.116c-.714 0-1.053-.362-1.116-.868l-.425-3.399A7.5 7.5 0 0 1 8.511 20q-.444 0-.884-.046l.365 2.923a1 1 0 0 1-.868 1.116c-.688 0-1.053-.362-1.116-.868l-.457-3.654a8.5 8.5 0 0 1-3.06-1.96 8.52 8.52 0 0 1-2.47-6.626C.323 6.611 4.333 3 8.778 3h.794c1.668 0 2.98-.937 3.787-1.723.25-.244.533-.461.84-.646a4.52 4.52 0 0 1 4.871.173 4.504 4.504 0 0 1 1.642 5.28c1.108 1.64 3.093 5.27 3.225 10.381m-4.946-12.18a2.49 2.49 0 0 0-1.073-1.846 2.49 2.49 0 0 0-3.164.272c-1.537 1.498-3.329 2.29-5.182 2.29h-.794c-3.375 0-6.535 2.816-6.762 6.026a6.52 6.52 0 0 0 1.887 5.07 6.52 6.52 0 0 0 5.07 1.887c3.21-.227 6.026-3.387 6.026-6.762V10.01c0-1.547.842-2.764 2.146-3.101a2.45 2.45 0 0 0 1.122-.641 2.5 2.5 0 0 0 .724-1.983"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-kiwi-bird_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrKiwiBird;
